import React from "react";
import "./Frame43.css";

function Frame43(props) {
  const { className } = props;

  return (
    <div className={`frame-4-60 ${className || ""}`}>
      <div className="place-251 subtitel">No</div>
    </div>
  );
}

export default Frame43;
